import WorkItemType from '@/domain/work-item/work-item-type.entity';
import WorkItemRelated from '@/domain/work-item/work-item-related.entity';
import ValidateEntityObject from '@/shared/utils/validate-entity-object';
import WorkItemProject from './work-item-project.entity';

export default abstract class WorkItemPersist {
  id: string;

  project: WorkItemProject;

  workItemNumber: number;

  title: string;

  status: string;

  workItemType: WorkItemType;

  createdDate: Date;

  originCreatedDate: Date;

  estimatedDeadLine: Date;

  createdBy: string;

  originalEstimate: number;

  storyPoints: number;

  effortSpent: number;

  originSystem: string;

  parent: WorkItemRelated | null;

  children: WorkItemRelated[];

  description: string;

  vstsIntegrationBlocked: boolean = false;

  constructor(obj: any) {
    this.id = obj.id;
    this.project = ValidateEntityObject.validate(obj.project, WorkItemProject.of);
    this.createdDate = obj.createdDate;
    this.originCreatedDate = obj.originCreatedDate;
    this.originSystem = obj.originSystem;
    this.title = obj.title;
    this.workItemNumber = obj.workItemNumber;
    this.estimatedDeadLine = obj.estimatedDeadLine;
    this.createdBy = obj.createdBy;
    this.workItemType = ValidateEntityObject.validate(obj.workItemType, WorkItemType.of);
    this.status = obj.status;
    this.originalEstimate = obj.originalEstimate;
    this.storyPoints = obj.storyPoints;
    this.effortSpent = obj.effortSpent || 0;
    this.originSystem = obj.originSystem;
    this.parent = (obj.parent === null || obj.parent === undefined)
      ? null
      : WorkItemRelated.of(obj.parent);
    this.children = WorkItemRelated.ofList(obj.children);
    this.description = obj.description;
    this.vstsIntegrationBlocked = obj.vstsIntegrationBlocked || false;
  }
}
